<div class="flex items-center items-stretch gap-2 lg:gap-4 w-full" id="header-component">
  @if (!desktopSidebarOpen()) {
    <p-panel [showHeader]="false" class="flex-shrink-0 lg:w-[17em] w-[min(20rem,85vw)] navigation-panel">
      <div class="flex min-h-12 items-center justify-between">
        <div class="flex items-center">
          <a [routerLink]="['/' + routes.homePath]">
            <img class="lg:size-12 size-8" src="https://www.acp-gruppe.com/hs-fs/hubfs/acp_logo_rgb_small.png?width=70&height=69&name=acp_logo_rgb_small.png" alt="ACP Logo" />
          </a>
          <h1 class="ml-4 font-semibold">GATE</h1>
        </div>
        <button (click)="expandSidebar()" class="icon-with-circle hidden lg:flex items-center justify-center cursor-pointer border rounded-full size-8 ml-2" type="button" aria-label="Expand Menu">
          <i class="pi pi-chevron-down text-xs"></i>
        </button>
      </div>
    </p-panel>
  }

  <p-panel [showHeader]="false" class="sticky-header-panel flex-1 min-w-0">
    <div class="flex min-h-12 items-center gap-3 lg:gap-4">
      <div class="grow flex items-center min-w-0 overflow-hidden">
        <gate-breadcrumb class="block w-full min-w-0" />
      </div>
    @if (!heroVisible()) {
    <div class="items-center lg:flex hidden flex-shrink-0" #globalSearch>
      <gate-searchbar class="w-full xl:min-w-[27rem] min-w-[12rem]"></gate-searchbar>
    </div>
    }
    <div class="items-center gap-4 lg:flex hidden flex-shrink-0 min-w-0">
      @if (isLoading || customer?.fullName || currentCustomerName) {
      <div class="px-4 min-w-[8rem]"
        [ngClass]="{'border-x border-slate-300 max-w-[12rem]':!heroVisible(), 'border-r border-slate-300 max-w-[22rem]':heroVisible()}">
        <p class="company-name w-full flex gap-2 justify-center items-center">
          @if (isLoading) {
          <i class="pi pi-spin pi-spinner"></i>
          }
          @else{
          @if (customerLogoUrl()) {
          <img [src]="customerLogoUrl()!" [alt]="customer?.fullName || currentCustomerName || 'Customer logo'"
            class="customer-logo" />
          } @else {
          <span class="company-name line-clamp-3">{{ customer?.fullName || currentCustomerName }}</span>
          }
          @if (canSwitchCustomer()) {
          <button (click)="menu.toggle($event)" class="icon-with-circle icon-with-circle-lg p-[0.75em] !m-0 !mr-[-0.75em]"
            id="customer-switch-button" aria-label="Switch Customer">
            <i class="pi pi-chevron-down"></i>
          </button>
          }
          }
        </p>
      </div>
      }
      <div class="text-sm min-w-[7rem] whitespace-pre xl:block hidden">
        <div>{{ user().familyName }}, {{ user().givenName }}</div>
        @if (customerLogoUrl()) {
        <div class="header-customer-name w-full ellipsis">{{ customer?.fullName || currentCustomerName }}</div>
        <div id="customer-id">({{ customer?.id || user().customerId }})</div>
        } @else {
        <div id="customer-id">({{ user().customerId }})</div>
        }
      </div>
      <gate-menu></gate-menu>
    </div>
  </div>
</p-panel>
</div>
<p-menu #menu [model]="customersMenuItem" [popup]="true" styleClass="p-2 w-[15rem] max-h-[30rem] overflow-y-auto">
  <ng-template #item let-item>
    <a pRipple class="flex align-items-center p-menu-item-link justify-between gap-2 text-sm p-2"
      (click)="switchCustomer($any(item).customerId)">
      <div class="flex items-center gap-2 min-w-0 flex-1">
        <button type="button" class="customer-preference-button"
          (click)="setPreferredCustomer($any(item).customerId, $event)" [disabled]="$any(item).isLoading"
          [title]="$any(item).isPreferred ? 'Preferred customer' : 'Set preferred customer'">
          <i class="pi" [ngClass]="{
              'pi-spinner pi-spin text-slate-400': $any(item).isLoading,
              'pi-heart-fill text-red-500': $any(item).isPreferred,
              'pi-heart text-slate-400': !$any(item).isPreferred && !$any(item).isLoading
            }"></i>
        </button>
        <span>
          <span class="line-clamp-2">{{ item.label }}</span>
          <span>({{ item.customerId }})</span>
        </span>
      </div>
      @if ($any(item).isCurrent) {
      <i class="pi pi-check text-primary text-xs"></i>
      }
    </a>
  </ng-template>
</p-menu>